export const CURRENCY = "৳";
